import Request from './request'

const Http = {
  addHeader (headers) {
    Request.addHeader(headers)
  }
}

export default Http
